import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function Reviewer() {
  return (
    <>
      <div>
        <TableList Role="Reviewer" />
      </div>
    </>
  );
}
